<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Update Equipment Status'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>

  <div class="ttmodal__body" *ngIf="isloading">
    <div style="align-items: center; display: block; margin-left:40%;">
      <mat-spinner></mat-spinner>
    </div>

  </div>


  <div class="ttmodal__body" *ngIf="!isloading">
    <div >
        <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
              <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
                {{ customer.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite" placeholder="{{Translate('Select Job Site')}}">
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
              <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                {{ equipment.Serial+ ' : ' + equipment.Unit }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="setup-form-full-width">
            <mat-select  name="equipment" placeholder="{{'Select Equipment Status'| translate | async}}" [(ngModel)]="SelectedStatus" >
              <mat-option [value]="0">Not in Use</mat-option>
              <mat-option [value]="1">In Use</mat-option>
              <mat-option [value]="2">Parked</mat-option>
              <mat-option [value]="3">Rental</mat-option>
              <mat-option [value]="4">Single Inspection</mat-option>
            </mat-select>
          </mat-form-field>

         
          <div class="ttmodal__footer">
            <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
            <button mat-raised-button color="warn" [disabled]="!equipmentSelected" (click)="UpdateEquipmentStatus()"><span class="material-icons button__icon">check</span><span
                class="button__text">{{'Update'| translate | async}}</span></button>
          </div>
    </div>
 
  </div>

</div>
